import {
  Box,
  Card,
  Link,
  Stack,
  Divider,
  Typography,
  CardHeader,
  CardContent,
} from '@mui/material';

export default function ZapierIntegration() {
  return (
    <Card>
      <CardHeader title="Zapier Integration" />
      <CardContent>
        <Stack spacing={3}>

          {/* How to Connect */}
          <Box>
            <Typography variant="h6" gutterBottom>
              How to Connect FlowBookings to Zapier
            </Typography>
            <Stack spacing={1}>
              {[
                'Accept the Zapier invite using the link in the banner above',
                'Log in to Zapier and click "Create Zap"',
                'Search for "FlowBookings" and select it',
                'Choose a trigger — for example, "New Booking"',
                'Click "Sign in to FlowBookings" and paste your API key from the left panel',
              ].map((step, index) => (
                <Typography key={index} variant="body2">
                  {index + 1}. {step}
                </Typography>
              ))}
            </Stack>
          </Box>

          <Divider />

          {/* Available Triggers */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Available Triggers
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Triggers start your Zap when something happens in FlowBookings:
            </Typography>
            <Stack spacing={0.75}>
              {[
                ['New Booking', 'When a customer creates a booking'],
                ['Booking Updated', 'When a booking is modified'],
                ['Booking Approved', 'When a booking is approved'],
                ['Booking Cancelled', 'When a booking is cancelled'],
                ['New Service', 'When you create a new service'],
                ['Service Updated', 'When you modify a service'],
              ].map(([name, desc]) => (
                <Typography key={name} variant="body2">
                  <strong>{name}</strong> — {desc}
                </Typography>
              ))}
            </Stack>
          </Box>

          <Divider />

          {/* Available Actions */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Available Actions
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Actions let Zapier make changes in your FlowBookings account:
            </Typography>
            <Stack spacing={0.75}>
              {[
                ['Update Booking Status', 'Approve, cancel, mark no-show, or complete a booking'],
                ['Find Booking', 'Look up a specific booking by its ID'],
                ['Find Service', 'Look up a specific service by its ID'],
              ].map(([name, desc]) => (
                <Typography key={name} variant="body2">
                  <strong>{name}</strong> — {desc}
                </Typography>
              ))}
            </Stack>
          </Box>

          <Divider />

          {/* Footer links */}
          <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
            <Link
              href="https://docs.flowbookings.io/knowledgebase/integrations/zapier-integration-guide"
              target="_blank"
              rel="noopener"
              variant="body2"
              sx={{fontWeight: 600}}
            >
              Read the full Zapier documentation
            </Link>
            <Link
              href="https://www.flowbookings.io/contact"
              target="_blank"
              rel="noopener"
              variant="body2"
              sx={{fontWeight: 600}}
            >
              Need help? Contact support
            </Link>
          </Stack>

        </Stack>
      </CardContent>
    </Card>
  );
}
